import { useEffect, useState } from "react";
import "./welcome.css";

const WelcomePage = () => {
  const [user] = useState(JSON.parse(localStorage.getItem("student")));
  const [activeProgram, setActiveProgram] = useState(() => {
    if (user.student.program === "tech-pro") {
      return "Tech Pro";
    }
    return "Tech Smart";
  });

  const techProCurriculum = [
    {
      title: "Frontend Development",
      details: "HTML, CSS, Bootstrap, Tailwind CSS, JavaScript, ReactJS",
    },
    {
      title: "Backend Development",
      details: "SQL, NodeJS, ExpressJS, MongoDB",
    },
    {
      title: "Python Programming Language",
      details: "Full Python Programming",
    },
    {
      title: "Real Time Projects",
      details: "Netflix, Amazon, Zomato/Swiggy, and more...",
    },
    {
      title: "Internship",
      details: "With Real-time Projects",
    },
  ];

  const techSmartCurriculum = [
    {
      title: "Frontend Development",
      details: "HTML, CSS, Bootstrap, Tailwind CSS, JavaScript, ReactJS",
    },
    {
      title: "Backend Development",
      details: "SQL, NodeJS, ExpressJS, MongoDB",
    },
    {
      title: "Projects Limited",
      details: "Mini and guided projects",
    },
  ];

  const curriculum =
    activeProgram === "Tech Pro" ? techProCurriculum : techSmartCurriculum;

  return (
    <div className="welcome-container">
      <div className="welcome-header">
        <h1 className="fade-in">
          Welcome to <span className="highlight">Zavrex IBIX</span>
        </h1>
        <p className="sub-text">Your Learning Schedule</p>
      </div>

      <div className="curriculum-section">
        <h2 className="program-title">{activeProgram} Curriculum</h2>
        <ul className="curriculum-list">
          {curriculum.map((item, index) => (
            <li key={index} className="curriculum-item">
              <h3>{item.title}</h3>
              <p>{item.details}</p>
            </li>
          ))}
        </ul>
      </div>

      <div className="bottom-line">
        <p>
          Learn Today, <span>Lead Tomorrow</span>
        </p>
      </div>
    </div>
  );
};

export default WelcomePage;
